import { ChangeEvent } from 'react'
import { Box, InputBase, FormControl } from '@mui/material'
import ellipse from '../../resources/Ellipse.svg'
import car from '../../resources/Car.svg'

interface licensePlateTextFieldProps {
  value: string
  onFocus: () => void
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  redeemPermit: () => void
  hasError: boolean
  useMoovyKeyboard: boolean
}

const licensePlateTextField = ({
  value,
  onFocus,
  onChange,
  redeemPermit,
  hasError,
  useMoovyKeyboard
}: licensePlateTextFieldProps) => {
  const handleEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      redeemPermit()
    }
  }

  return (
    <FormControl
      error={hasError}
      sx={{
        display: 'flex',
        width: '98%',
        height: { xs: '60px', sm: '75px' },
        border: hasError
          ? { xs: '3px solid #ff4848', sm: '4px solid #ff4848' }
          : { xs: '3px solid #5a5a5a', sm: '4px solid #5a5a5a' },
        backgroundColor: 'white',
        borderRadius: '16px',
        position: 'relative'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          width: '98%',
          height: { xs: '60px', sm: '75px' },
          backgroundColor: 'white',
          borderRadius: '16px',
          position: 'relative'
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: { xs: '55px', sm: '65px' },
            height: '100%',
            backgroundColor: '#0098d8',
            borderTopLeftRadius: { xs: '12.5px', sm: '11px' },
            borderBottomLeftRadius: { xs: '12.5px', sm: '11px' },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Box
            component="img"
            src={ellipse}
            alt="Icon"
            sx={{
              width: { xs: 25, sm: 30 },
              height: { xs: 25, sm: 30 },
              marginBottom: '8px'
            }}
          />
          <Box
            component="img"
            src={car}
            alt="Icon"
            sx={{
              width: { xs: 25, sm: 30 },
              height: { xs: 21, sm: 26 }
            }}
          />
        </Box>
        <Box sx={{ display: 'flex' }}>
          <InputBase
            sx={{
              fontSize: { xs: '2rem', sm: '3rem' },
              fontWeight: '600',
              textAlign: 'center',
              ml: { xs: 7, sm: 7 },
              height: { xs: 1, sm: 1 },
              '& input': {
                textAlign: 'center'
              }
            }}
            placeholder="ABC123"
            value={value}
            onFocus={onFocus}
            onChange={onChange}
            onKeyDown={handleEnter}
            inputProps={
              useMoovyKeyboard
                ? { inputMode: 'none', readOnly: true }
                : { readOnly: false }
            }
          />
        </Box>
      </Box>
    </FormControl>
  )
}

export default licensePlateTextField
